import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import {
  convertStraight,
  formatDateTime,
} from "../../components/common-data/Converts";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import DetailListings from "../../components/staff-onboarding/detail-modal/DetailListings";
import OnBoardingFormLanding from "../../components/staff-onboarding/on-boarding-form/OnBoardingFormLanding";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const DeletedStaff = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  userInfoData,
  callFunction,
}) => {
  const { deletedStaffLoading, deletedStaffError, deletedStaff } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function onCloseModal() {
    setModValues(iniModValues);
  }

  useEffect(() => {
    if (
      !deletedStaffLoading &&
      !deletedStaffError &&
      deletedStaff?.status &&
      deletedStaff?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: deletedStaff.data,
        pagination:
          deletedStaff?.pagination?.length > 0 ? deletedStaff.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [deletedStaffLoading, deletedStaffError, deletedStaff]);

  const tbColumns = [
    {
      dataField: "uid",
      text: "staff Details",
      formatter: (_, row) => (
        <div className="multi-row-table-td minWidth200">
          <small
            className="tb-data mid-padding mid-radius"
            style={{
              background: "#F64E60",
              color: "#fff",
              letterSpacing: "1px",
            }}
          >
            {row?.account_type?.replace(/_/g, " ") || "-"}
          </small>

          <span className="tb-data text-start">{row?.name || "NA"}</span>

          <div
            className="highlighted-dotted-line"
            style={{ border: "1px solid gray", borderStyle: "dotted" }}
          ></div>

          <small className="tb-data text-start text-initial">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-phone-fill"
              viewBox="0 0 16 16"
            >
              <path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
            </svg>{" "}
            {row?.mobile || ""}
          </small>
          <small className="tb-data text-start text-initial text-lowercase">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-envelope-open-fill"
              viewBox="0 0 16 16"
            >
              <path d="M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.314l6.709 3.932L8 8.928l1.291.718L16 5.714V5.4a2 2 0 0 0-1.059-1.765zM16 6.873l-5.693 3.337L16 13.372v-6.5Zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516M0 13.373l5.693-3.163L0 6.873z" />
            </svg>{" "}
            {row?.email || ""}
          </small>
          <small className="tb-data text-start text-initial">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-calendar-event-fill"
              viewBox="0 0 16 16"
            >
              <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5" />
            </svg>{" "}
            {row?.date_added ? formatDateTime(row.date_added) : ""}
          </small>
        </div>
      ),
    },
    {
      dataField: "gym_id",
      text: "gym",
      formatter: (_, row) => {
        const isMultiGym =
          row?.account_type === "cluster_manager" ||
          row?.account_type === "fitness_manager" ||
          row?.account_type === "club_manager" ||
          row?.account_type === "sales_manager";

        return (
          <div className="tb-data tb-data-long text-start minWidth150">
            {isMultiGym && row?.gyms_info?.length > 0
              ? row?.gyms_info?.map((gym) => (
                  <>
                    <span
                      style={{
                        display: "inline-block",
                        width: "8px",
                        height: "8px",
                        backgroundColor: "#10B981",
                        borderRadius: "50%",
                        marginRight: "6px",
                        flexShrink: 0,
                      }}
                    ></span>
                    {gym?.gym_name}{" "}
                  </>
                ))
              : row?.gym_name || "NA"}
          </div>
        );
      },
    },
    // {
    //   dataField: "gym_id",
    //   text: "gym",
    //   formatter: (_, row) => {
    //     return (
    //       <div className="tb-data text-center minWidth150">
    //         {row?.gym_name || "NA"}
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "is_exists",
      text: "On Boarding	",
      formatter: (_, row) => {
        return (
          <span className="tb-data text-center icon">
            {row?.is_exists ? (
              <CheckCircleIcon />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-hourglass-split"
                viewBox="0 0 16 16"
                style={{ color: "#d9610b" }}
              >
                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
              </svg>
            )}
          </span>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "Approval",
      formatter: (_, row) => {
        return (
          <span className="tb-data text-center icon">
            {row?.approval_status === 1 ? (
              <CheckCircleIcon />
            ) : row?.approval_status === -1 ? (
              <CrossCircleIcon />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-hourglass-split"
                viewBox="0 0 16 16"
                style={{ color: "#d9610b" }}
              >
                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
              </svg>
            )}
          </span>
        );
      },
    },
    // {
    //   dataField: "salary",
    //   text: "salary",
    //   formatter: (_, row) => {
    //     return (
    //       <div className="tb-data text-center">
    //         ₹{convertThenFormat(row?.salary || 0)}
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "approval_status",
      text: "Biometric Status",
      formatter: (_, row) => {
        const isBiomatric = Number(row?.total_check_in || 0) > 0;

        return (
          <span className="tb-data text-center icon">
            {isBiomatric ? (
              <CheckCircleIcon />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-hourglass-split"
                viewBox="0 0 16 16"
                style={{ color: "#d9610b" }}
              >
                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
              </svg>
            )}
          </span>
        );
      },
    },
    {
      dataField: "joining_date",
      text: "joining date",
      formatter: (_, row) => {
        return (
          <div className="tb-data text-center minWidth100">
            {row?.joining_date ? convertStraight(row.joining_date) : "-"}
          </div>
        );
      },
    },
    {
      dataField: "details",
      text: "view details",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-eye-fill"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>
            </button>
          </div>
        );
      },
    },
    isAdmin && {
      dataField: "action",
      text: "re-onboard",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              className="actionBtn icon view"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "re-onboard",
                  rowData: row,
                }))
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-person-plus-fill"
                viewBox="0 0 16 16"
              >
                <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                <path
                  fillRule="evenodd"
                  d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5"
                />
              </svg>
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "staff_photo" ||
            modValues.cardName === "view_details"
              ? "mod-width-50p"
              : ""
          }`}
        >
          {(modValues.cardName === "staff_photo" ||
            modValues.cardName === "view_details") && (
            <ModalHeadAndClose
              title={
                modValues.cardName === "staff_photo" ||
                modValues.cardName === "view_details"
                  ? modValues.rowData?.name
                  : modValues.cardName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />
          )}

          {modValues.cardName === "staff_photo" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.image}
                alt={modValues.rowData?.name}
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.cardName === "view_details" ? (
            <DetailListings row={modValues.rowData} />
          ) : modValues.cardName === "re-onboard" ? (
            <OnBoardingFormLanding
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={callFunction}
              isEdit={modValues.cardName === "re-onboard"}
              rowData={modValues.rowData}
              isReOnboard={true}
            />
          ) : null}
        </div>
      </Modal>

      {deletedStaffLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table">
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        </div>
      )}
    </>
  );
};

export default DeletedStaff;
